import { Button, Card, Col, Collapse, Container, Form, Modal, Row, Stack, Tab, Tabs } from "react-bootstrap";
import styles from "./BlueToGo.module.css";
import { useEffect, useState } from "react";
import { activacionBlueToGo, consultaLDAP, consultaSolicitudServicio } from "../BlueToGo/servicios";
import { Atributo } from "../Commons/Services/ConsultarLDAP";
import BannerCA from "../assets/img/blue/BannerCA.png"
import BannerSmallCA from "../assets/img/blue/BannerCA320px.png";
import Banner from "../assets/img/blue/Banner.png";
import BannerSmall from "../assets/img/blue/Banner320px.png";
import { DetalleSolicitudDeServicio } from "../Commons/Services/ConsultaSolicitudDeServicioRest";
import { Link, useNavigate } from "react-router-dom";



const BlueToGoInicio = ({ statusContratacion }: any) => {

    const navigate = useNavigate();

    const [moneda, setMoneda] = useState<string>();
    const costos = { mexico: "$20 MXN", costaRica: "₡599 CRC", guatemala: "Q7.90 GTQ", republicaDominicana: "$50 DOP" };


    // const costos = { costaRica: "₡599 CRC", guatemala: "Q7.90 GTQ", republicaDominicana: "$50 DOP", mexico: "$20 MXN", eeuu: "$1 USD" ,salvador : "$1 USD" , honduras: "$1 USD", nicaragua : "$1 USD"};

    const handlerActivacion = () => {
        if (statusContratacion === false) {
            navigate("/bluetogoterminos");
        } else {
            //Link("https://www.skymas.com.mx");
        }

    }

    function determinaPrecio(pais: string, flujo: string) {
        if (flujo == "Sky+") {

            return costos.mexico
        }
        else {

            switch (pais) {
                case "CRICA":
                    return costos.costaRica;
                case "DOM":
                    return costos.republicaDominicana;
                case "GT":
                    return costos.guatemala;
                case "MEX":
                    return costos.mexico;
                default:
                    return "$1 USD"

            }

        }

    }

    function isBannerMexico(pais: string) {
        if ( pais == null ){
            return true ; 
        }  else {
            switch (pais) {

                case "MEX":
                    return true;
                default:
                    return false;
    
            }

        }


    }

    // const consultarLDAP= async()=>{
    //     const  respuesta = await consultaLDAP();
    //     setLDAP(respuesta);
    //   }   

    // const consultarSolicitudServicio= async()=>{
    //     const  respuesta = await consultaSolicitudServicio();
    //     setSolicitudServicio(respuesta);
    // } 

    // const activacionBlue= async()=>{
    //   const  respuesta = await activacionBlueToGo();
    //   setSolicitudServicio(respuesta);


    useEffect(() => {

        setMoneda(determinaPrecio(sessionStorage.getItem("pais")!, sessionStorage.getItem("flujos")!));

        //consultarLDAP();
        //consultarSolicitudServicio();
        //determinaBlueContratado();
        //activacionBlue();

    }, []);

    return (
        <>
            <Container  >
                <Row >
                    <div id="big" className="d-none d-xl-block d-lg-block">

                        
                        <Row>
                            {isBannerMexico(sessionStorage.getItem("pais")!) ? <img src={Banner} className={styles.imagen} /> : <img src={BannerCA} className={styles.imagen} />}

                        </Row>
                    </div>


                    <div id="small" className="d-lg-none d-xl-none">
                        <Row>
                            {isBannerMexico(sessionStorage.getItem("pais")!) ? <img src={BannerSmall} className={styles.imagen} /> : <img src={BannerSmallCA} className={styles.imagen} />}

                        </Row>
                    </div>

                    <br />
                    {statusContratacion ? <>
                        <p className="pb-4">
                        </p>
                    </> :

                        <><Col className={styles["alturagradiente"]}>
                            <span className={styles["azulgradient"]}>Contrata por {moneda} al mes.</span>
                        </Col>
                            <p className={styles["contenidoParrafo"] + "pb-5"}>
                                <span className="pb-5">Disfruta en línea las mejores exclusivas de Sky como LaLiga Española, Premier League, copas europeas de fútbol, tenis de la ATP, maratones, conciertos, series y mucho más.</span>

                                <span>Disfruta de Sky+ cuando quieras y donde quieras.</span>
                            </p>
                        </>}

                    {statusContratacion === false ? <>
                        <Button
                            onClick={handlerActivacion}
                            variant="primary"
                            className={styles["botonazul"]}
                        >

                            Contratar
                        </Button></> : <>                    <Button
                            href="https://www.skymas.mx"
                            target="_blank"
                            variant="primary"
                            className={styles["botonazul"]}
                        >

                            Ir a Sky+
                        </Button></>}





                </Row>
            </Container>
        </>
    );

}

export default BlueToGoInicio;